export const NHL_NEW = {
  P1: "https://drive.google.com/file/d/1DzV6R497gxUS-PO0aQlam_i49Q9kXW6y/view?usp=sharing",
  P2: "https://drive.google.com/file/d/1PB2tq4nesl7J3rBFzbhQLiIUgq2bCB_-/view?usp=sharing",
  SOG1: "https://drive.google.com/file/d/1UkBhxJx2JtCiljYGttWYHi2fXMoJlXCv/view?usp=sharing",
  SOG2: "https://drive.google.com/file/d/1mrhM1X3GH3wqDvMQqIUTIj91MrYYbAmR/view?usp=sharing",
  GOAL1:
    "https://drive.google.com/file/d/1pHZ4mMjei_p8sbhrJ6P1kavhJkQEIBEU/view?usp=sharing",
  FO1: "https://drive.google.com/file/d/1NRuBpHieEKM4zFY8q41SLFsTXFJGG7oO/view?usp=sharing",
};

export const NFL2 = {
  "1st":
    "https://drive.google.com/file/d/1b2-P6DPeFL3aumCGOaOq0GkI6wHUJSvf/view?usp=sharing",
  PEN2: "https://drive.google.com/file/d/1iQZmftuYjHDhxPruiFmg6S5YH_RoFXRu/view?usp=sharing",
  SACK: "https://drive.google.com/file/d/1x9dCPkPJADfuUmn5AKFoGFAyfI0zkquF/view?usp=sharing",
  TD: "https://drive.google.com/file/d/1jkNwW9jruoE2gZQsdQbhnAz9EiaA0e8k/view?usp=sharing",
  FGMS2:
    "https://drive.google.com/file/d/1xl5HHtsgeB95EmESydBIaYoWTT--G5Dz/view?usp=sharing",
  FGMS1:
    "https://drive.google.com/file/d/1xl5HHtsgeB95EmESydBIaYoWTT--G5Dz/view?usp=sharing",
  TO2: "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  PTO2: "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  KOTO1:
    "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  PUNT2:
    "https://drive.google.com/file/d/1m541ZL4VLmpDHdFSZK4MxLQ2xJiqmzfq/view?usp=sharing",
  SAFETY:
    "https://drive.google.com/file/d/1KbvEDOq__RO1TvJDHyKgF1afv-jAd0ox/view?usp=sharing",
  PASS: "https://drive.google.com/file/d/14BjY_TjM9vDytTokXJZw-1o53smQYLHk/view?usp=sharing",
  RUN: "https://drive.google.com/file/d/14BjY_TjM9vDytTokXJZw-1o53smQYLHk/view?usp=sharing",
  FG: "https://drive.google.com/file/d/1pJrRN55_gCancTUJCgNTtcGM2bh1yjyo/view?usp=sharing",
  "FG+":
    "https://drive.google.com/file/d/1pJrRN55_gCancTUJCgNTtcGM2bh1yjyo/view?usp=sharing",
  TFL: "https://drive.google.com/file/d/1RjKZqF4WiXrUX-NYqVigVCLY-mSRHXs4/view?usp=sharing",
};

export const MLB_NEW = {
  HR1: "https://drive.google.com/file/d/1JONvx6eigdJhIMs2YalIUKzgXe8iim9B/view?usp=sharing",
  FCER1:
    "https://drive.google.com/file/d/1yWG2fXygs0U0JBQDsI5YCe3QVOLF3fMF/view?usp=sharing",
  E1: "https://drive.google.com/file/d/1yWG2fXygs0U0JBQDsI5YCe3QVOLF3fMF/view?usp=sharing",
  HBP1: "https://drive.google.com/file/d/1yWG2fXygs0U0JBQDsI5YCe3QVOLF3fMF/view?usp=sharing",
  SINGLE1:
    "https://drive.google.com/file/d/1yWG2fXygs0U0JBQDsI5YCe3QVOLF3fMF/view?usp=sharing",
  WALK1:
    "https://drive.google.com/file/d/1yWG2fXygs0U0JBQDsI5YCe3QVOLF3fMF/view?usp=sharing",
  RBI1: "https://drive.google.com/file/d/1c4IrkqFODyw4xosBfA4RdnbFfVZiSi3J/view?usp=sharing",
  RBI2: "https://drive.google.com/file/d/1c4IrkqFODyw4xosBfA4RdnbFfVZiSi3J/view?usp=sharing",
  STEAL1:
    "https://drive.google.com/file/d/12DvUuM3L_cDVrGyWANd7AiMRLlTfUK-R/view?usp=sharing",
  KL2: "https://drive.google.com/file/d/1dHBPmYEVJZxdxXr0RFlsfBLc0iiMEqY7/view?usp=sharing",
  KS2: "https://drive.google.com/file/d/1dHBPmYEVJZxdxXr0RFlsfBLc0iiMEqY7/view?usp=sharing",
  OUTK2:
    "https://drive.google.com/file/d/1dHBPmYEVJZxdxXr0RFlsfBLc0iiMEqY7/view?usp=sharing",
  DBPL2:
    "https://drive.google.com/file/d/1Snw1979KFo_ud2k5dbis5dzl4UmVAc0a/view?usp=sharing",
  TRIPLE1:
    "https://drive.google.com/file/d/1Ad5rDgCyt74o1PKGQaW7l06xuRDo8h3W/view?usp=sharing",
  DOUBLE1:
    "https://drive.google.com/file/d/1P5i1LXtqmpFfeLJP0Ec6LNJgVeymwWD-/view?usp=sharing",
};

export const NCAAFB2 = {
  PEN: "https://drive.google.com/file/d/1iQZmftuYjHDhxPruiFmg6S5YH_RoFXRu/view?usp=sharing",
  "1ST":
    "https://drive.google.com/file/d/1b2-P6DPeFL3aumCGOaOq0GkI6wHUJSvf/view?usp=sharing",
  SACK1:
    "https://drive.google.com/file/d/1x9dCPkPJADfuUmn5AKFoGFAyfI0zkquF/view?usp=sharing",
  TD1: "https://drive.google.com/file/d/1jkNwW9jruoE2gZQsdQbhnAz9EiaA0e8k/view?usp=sharing",
  FGMS2:
    "https://drive.google.com/file/d/1xl5HHtsgeB95EmESydBIaYoWTT--G5Dz/view?usp=sharing",
  FGMS1:
    "https://drive.google.com/file/d/1xl5HHtsgeB95EmESydBIaYoWTT--G5Dz/view?usp=sharing",
  TO2: "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  PTO2: "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  KOTO2:
    "https://drive.google.com/file/d/1yDS3DkhcEoegvUOcKL9nC_T1sKlz-Yb1/view?usp=sharing",
  PUNT2:
    "https://drive.google.com/file/d/1m541ZL4VLmpDHdFSZK4MxLQ2xJiqmzfq/view?usp=sharing",
  SAFETY:
    "https://drive.google.com/file/d/1KbvEDOq__RO1TvJDHyKgF1afv-jAd0ox/view?usp=sharing",
  PASS: "https://drive.google.com/file/d/14BjY_TjM9vDytTokXJZw-1o53smQYLHk/view?usp=sharing",
  RUN: "https://drive.google.com/file/d/14BjY_TjM9vDytTokXJZw-1o53smQYLHk/view?usp=sharing",
  FG1: "https://drive.google.com/file/d/1pJrRN55_gCancTUJCgNTtcGM2bh1yjyo/view?usp=sharing",
  "FG+":
    "https://drive.google.com/file/d/1pJrRN55_gCancTUJCgNTtcGM2bh1yjyo/view?usp=sharing",
  TFL: "https://drive.google.com/file/d/1RjKZqF4WiXrUX-NYqVigVCLY-mSRHXs4/view?usp=sharing",
};

export const NBA_NEW = {
  FTMK1:
    "https://drive.google.com/file/d/14IbS4Xs7hzvfOYSGjuXyrgccBHt2Vdt5/view?usp=sharing",
  FTMK2:
    "https://drive.google.com/file/d/15ZvaQwr-OmvCA7VNbnb4tEpOB1quhUJw/view?usp=sharing",
  "3PT1":
    "https://drive.google.com/file/d/1Z8GEVlyHO05ywKNPniRYZ7BcGKou5ZIs/view?usp=sharing",
  "3PT2":
    "https://drive.google.com/file/d/11mpQ3LKUb3IvuOlTzEKF-fSlP7IaM_RB/view?usp=sharing",
  FTMS1:
    "https://drive.google.com/file/d/1XnOyuYAp2ghjObU1y5Hk7rKzj04HLHsT/view?usp=sharing",
  FTMS2:
    "https://drive.google.com/file/d/1XnOyuYAp2ghjObU1y5Hk7rKzj04HLHsT/view?usp=sharing",
  DUNK1:
    "https://drive.google.com/file/d/19fKs_2fMWs4T_bq6bZJNMyhwbcWVFNpg/view?usp=sharing",
  FL2: "https://drive.google.com/file/d/1ZYtm89pJqOJ2a9xWh22Hw9t2D5hxcMZV/view?usp=sharing",
  FOUL1:
    "https://drive.google.com/file/d/1ZYtm89pJqOJ2a9xWh22Hw9t2D5hxcMZV/view?usp=sharing",
  OFL2: "https://drive.google.com/file/d/1l4xKSXyBCkSu2_mb75cdYV2Xuf1uF1ke/view?usp=sharing",
  BLK1: "https://drive.google.com/file/d/13p0XZ_--GfceesiF8eaPWkAKtaoKNjHm/view?usp=sharing",
};

export const NCAABB_NEW = {
  FTMK2:
    "https://drive.google.com/file/d/15ZvaQwr-OmvCA7VNbnb4tEpOB1quhUJw/view?usp=sharing",
  "3MK2":
    "https://drive.google.com/file/d/11mpQ3LKUb3IvuOlTzEKF-fSlP7IaM_RB/view?usp=sharing",
  FTMS1:
    "https://drive.google.com/file/d/1XnOyuYAp2ghjObU1y5Hk7rKzj04HLHsT/view?usp=sharing",
  FTMS2:
    "https://drive.google.com/file/d/1XnOyuYAp2ghjObU1y5Hk7rKzj04HLHsT/view?usp=sharing",
  DUNK1:
    "https://drive.google.com/file/d/19fKs_2fMWs4T_bq6bZJNMyhwbcWVFNpg/view?usp=sharing",
  FL2: "https://drive.google.com/file/d/1ZYtm89pJqOJ2a9xWh22Hw9t2D5hxcMZV/view?usp=sharing",
  FL1: "https://drive.google.com/file/d/1ZYtm89pJqOJ2a9xWh22Hw9t2D5hxcMZV/view?usp=sharing",
  BLK1: "https://drive.google.com/file/d/13p0XZ_--GfceesiF8eaPWkAKtaoKNjHm/view?usp=sharing",
};
